import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-files-widget-skeleton',
  templateUrl: './files-widget-skeleton.component.html',
  styleUrls: ['./files-widget-skeleton.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FilesWidgetSkeletonComponent {}
